import React, { useEffect, useState, Fragment, useRef } from "react";
//import { TableContent } from '../../../Common/Table/tableContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const attendance = this.props.attendance;

        return (
            <div>
                <h3><center><u>Daily Attendance Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>State: </b> {searchData.estate}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>


                <div>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Registration Number</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Employee Name
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        In time
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Out time
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {attendance.map((row) => (
                                    <TableRow key={row.employeeCode}>
                                        <TableCell component="th" scope="row">
                                            {row.registrationNumber}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.firstName}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.Intime3}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.Outtime3}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        );
    }
}


